// extracted by mini-css-extract-plugin
export var actionButton = "_pd-0";
export var actionMenuContainer = "_pd-i";
export var bubble = "_pd-2";
export var bubbleActionMenu = "_pd-j";
export var bubbleContext = "_pd-6";
export var bubbleItems = "_pd-7";
export var customer = "_pd-3";
export var divider = "_pd-8";
export var fileList = "_pd-9";
export var hiddenComment = "_pd-o";
export var infoAbove = "_pd-a";
export var internal = "_pd-4";
export var lightActionButton = "_pd-1";
export var link = "_pd-b";
export var merchant = "_pd-5";
export var message = "_pd-c";
export var profilePicture = "_pd-e";
export var quillToolbarContainer = "_pd-f";
export var senderDate = "_pd-g";
export var senderDateCustomer = "_pd-h";
export var senderName = "_pd-d";
export var time = "_pd-k";
export var uploadedImage = "_pd-l";
export var username = "_pd-m";
export var xsmall = "_pd-n";